import { put, post } from '../services/common/common.service';
import { serviceLevelEndPoints } from '../constants/endpoint';
import { GRID_ROW_ID } from '../constants';

export const createServiceLevel = (payload) =>
  post(serviceLevelEndPoints.serviceLevel, payload);

export const updateServiceLevel = (payload) =>
  put(
    `${serviceLevelEndPoints.serviceLevel}/${
      payload[GRID_ROW_ID.serviceLevel]
    }`,
    payload
  );

export const deactivateAndActivateServiceLevel = (payload) =>
  put(`${serviceLevelEndPoints.ServiceLevelStatus}`, payload);

//Earlier GET API used to fetch Service Level replaced with this new POST API to support filters
export const fetchServiceLevelUpdated = (payload) =>
  post(serviceLevelEndPoints.serviceLevelSearchUpdated, payload);
